import client from './client';

const studyApi = {
  get: (type, slug)         => client.get(`/study/${type}/${slug}`).then(r => r.data),
  patch: (type, slug, body) => client.patch(`/study/${type}/${slug}`, body).then(r => r.data),
  all: ()                   => client.get('/study/my/all').then(r => r.data),
};

export default studyApi;
